var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartCricle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0769 13H19.6953V13.1671V16.5678H27.0769V13Z",
    fill: "#7BC658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8032 14.0586H15.9062V16.5679H18.8032V14.0586Z",
    fill: "#7BC658"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0328 32.9993C26.6097 32.9993 27.0774 32.5316 27.0774 31.9547C27.0774 31.3778 26.6097 30.9102 26.0328 30.9102C25.4559 30.9102 24.9883 31.3778 24.9883 31.9547C24.9883 32.5316 25.4559 32.9993 26.0328 32.9993Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7594 32.9993C18.3363 32.9993 18.804 32.5316 18.804 31.9547C18.804 31.3778 18.3363 30.9102 17.7594 30.9102C17.1825 30.9102 16.7148 31.3778 16.7148 31.9547C16.7148 32.5316 17.1825 32.9993 17.7594 32.9993Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1001 19.96H18.8049H19.6963H25.4442L25.0595 21.1414H17.5861L17.1001 19.96Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartCricle);
export default __webpack_public_path__ + "static/media/shopping-cart-cricle.b754b5f12d10ed979b0df038c385f894.svg";
export { ForwardRef as ReactComponent };